import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import FieldTitle, {translate} from 'admin-on-rest';

function datify(input) {
    if (!input) {
        return null;
    }

    const date = input instanceof Date ? input : new Date(input);
    if (isNaN(date)) {
        throw new Error(`Invalid date: ${input}`);
    }

    return date;
};

function onChange (_, date) {
		this.input.onChange(date.toISOString());
        this.input.onBlur();
    };
	
const CHDateInput = ({ input, defaultValue, realDefaultValue, label, meta: { touched, error }, options }) => (
 	
	
	<DatePicker
		key="2"
		{...input}
		errorText={touched && error}
		floatingLabelText={
			label
		}
		DateTimeFormat={Intl.DateTimeFormat}
		container="inline"
		autoOk
		defaultDate={datify(realDefaultValue)}
		value={datify(realDefaultValue)}
		onChange={onChange}
		onBlur={this.onBlur}
		onDismiss={this.onDismiss}
		input = {input}
		{...options}
	/>

);

CHDateInput.propTypes = {
    addField: true,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
};

CHDateInput.defaultProps = {
    addField: true,
    options: {},
};

//export default CHDateInput;

export default CHDateInput;



// WEBPACK FOOTER //
// ./src/utils/CHDateInput.js